/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import * as siteHelpers from '@helpers/site'
import { declOfNum } from '@helpers/site'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import SymbolRuble from '../../../../../../shared/SymbolRuble/SymbolRuble'
import * as S from './BasketGoodPriceDescription.styled'
import { useShipment } from '@entities/shipment/model'
import { useOpenStockForGoods } from 'src/features/shipment-selector/hooks'
import { useIsDelivery } from 'src/pages/order/basket/hooks'

const DeliveryNotAvailableModal = ({ reasons }) => {
    const [isShowDeliveryReason, setIsDeliveryReason] = useState(false)
    const toggleDeliveryReason = () => setIsDeliveryReason(!isShowDeliveryReason)
    return (
        <React.Fragment>
            {isShowDeliveryReason && (
                <ModalWindow
                    title="Внимание"
                    isMobile
                    isButtonFooter={false}
                    isFooterOnlyOneButton
                    cancel={{
                        text: 'Понятно',
                        clickHandler: toggleDeliveryReason
                    }}>
                    <S.ReasonContainer>
                        {reasons.map((reason) => (
                            <S.ReasonTextItem
                                key={reason.id}
                                dangerouslySetInnerHTML={{ __html: reason.warningText }}
                            />
                        ))}
                    </S.ReasonContainer>
                </ModalWindow>
            )}
            <S.PriceItemContainer>
                <S.PriceItem>
                    <S.ShipmentTitle onClick={toggleDeliveryReason}>
                        Доставка <S.DeliveryStatusTitle>невозможна</S.DeliveryStatusTitle>
                    </S.ShipmentTitle>
                </S.PriceItem>
            </S.PriceItemContainer>
        </React.Fragment>
    )
}

const BasketGoodPriceDescription = ({ isSelectedStock, good }) => {
    const isDelivery = useIsDelivery()
    const openStockForGoods = useOpenStockForGoods()
    const shipment = useShipment()
    const clickOpenAnotherStockHandler = () => openStockForGoods([good.webData.goodId])
    const isSelectedAddress = !!shipment.shipAddressId
    const priceFroStock = good.isAvailableOnStock ? good.stockPrice : good.minPrice
    const price = isDelivery ? good.deliveryPrice : priceFroStock
    const isDeliveryAvl = good.deliveryStatus?.isAvailableForDelivery || good.isAvailableDeliveryByErecipe
    const isAvailable = isDelivery ? isDeliveryAvl : good.isAvailableOnStock
    const isChangedCount = good.bookedCount < good.count && good.isChanged

    if (!good.isAvailable || !price.normal)
        return (
            <S.Container>
                <S.PriceItemContainer>
                    <S.PriceItem>
                        <S.AnotherStockCountDescription>Нет в наличии</S.AnotherStockCountDescription>
                    </S.PriceItem>
                </S.PriceItemContainer>
            </S.Container>
        )

    const getAnotherStockDescription = () => {
        if (good.availableStocksCount) {
            return (
                <S.AnotherStockCountDescription onClick={clickOpenAnotherStockHandler}>
                    Нет в выбранной, самовывоз из {good.availableStocksCount}{' '}
                    {declOfNum(good.availableStocksCount, ['аптеки', 'аптек', 'аптек'])}
                </S.AnotherStockCountDescription>
            )
        }
        return <S.AnotherStockCountDescription>Нет в выбранной</S.AnotherStockCountDescription>
    }

    if (isDelivery && !isAvailable) {
        return <DeliveryNotAvailableModal reasons={good.deliveryStatus.reasons} />
    }

    return (
        <S.PriceItemContainer>
            <S.PriceItem>
                {!isAvailable && isSelectedStock ? (
                    getAnotherStockDescription()
                ) : (
                    <S.ShipmentTitle>
                        {isDelivery ? 'Доставка' : 'Самовывоз'}{' '}
                        {(!price.isDemand && isSelectedAddress && isDelivery) || (!price.isDemand && !isDelivery)
                            ? 'сегодня'
                            : ''}
                        {price.isDemand && <S.DateRed>{siteHelpers.convertDate(price.aptEtaDateTime)}</S.DateRed>}
                    </S.ShipmentTitle>
                )}
                {price.withoutPromo ? (
                    <S.PriceBlock>
                        <S.PriceDataOld>
                            {price.withoutPromo.toLocaleString('RU-ru')} <SymbolRuble />
                        </S.PriceDataOld>
                        <S.PriceNumberSaleBold>
                            {price.normal.toLocaleString('RU-ru')} <SymbolRuble />
                        </S.PriceNumberSaleBold>
                    </S.PriceBlock>
                ) : (
                    <S.PriceBlock>
                        {!isAvailable && !isDelivery ? (
                            <S.PriceSumFrom onClick={clickOpenAnotherStockHandler}>
                                от {price.normal.toLocaleString('RU-ru')} <SymbolRuble />
                            </S.PriceSumFrom>
                        ) : (
                            <S.PriceSum>
                                {price.normal.toLocaleString('RU-ru')} <SymbolRuble />
                            </S.PriceSum>
                        )}
                    </S.PriceBlock>
                )}
            </S.PriceItem>
            {isChangedCount && (
                <S.PreorderWarningContainer>
                    <S.WarningCountSpan>В наличии {good.bookedCount} уп.</S.WarningCountSpan>
                </S.PreorderWarningContainer>
            )}
        </S.PriceItemContainer>
    )
}

BasketGoodPriceDescription.propTypes = {}

export default BasketGoodPriceDescription
